module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyBAMAAABYG2ONAAAAHlBMVEUAAAAAmzoHBgAHnThqVwBqsiLjuwDjywbpwAD+0QBTk0lxAAAApklEQVR4Xp3WQQ0CQQyG0bGAByysASysCiQgAQPAuGUunL7DI/PfX9ImbdoxV97n5a8cj7kyZgzEIjEQi8RAzHGPgXiNawzEbcRYxFDEUMRY1EDIVMhUyFTIVMhUyFTQVNhU2ETIrETARMBE2ETYPH/iY2GyX5jbt4CBgMHAUOwMcgwFjRfZogZCpkKmQqZCpsLGwkfMxsIH2SaCZuchiYDZe64iaL71IzRxhHxHRQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/jm.png
// module id = PrSh
// module chunks = 0